import { type RootState } from ".";

export function getIsAuthAdmin(state: RootState) {
  return !!state.auth.isAdminUser;
}

export function getIsAuthLoading(state: RootState) {
  return state.auth.isLoading;
}

export function getIsAuthLoggedIn(state: RootState) {
  return !!state.auth.isLoggedIn;
}

export function getAuthUser(state: RootState) {
  return state.auth.user;
}
